// アコーディオンの要素を取得
const items = document.querySelectorAll('.accordion-item');

// 各アイテムにクリックイベントリスナーを追加
items.forEach(item => {
  const header = item.querySelector('.accordion-header');
  const content = item.querySelector('.accordion-content');

  header.addEventListener('click', function() {
    // クリックされたアイテムの表示状態を切り替える
    item.classList.toggle('active');

    // コンテンツの表示状態を切り替える
    content.classList.toggle('active');
    if (content.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '0';
    }
  });
});